$('.thumbnail-image').mousemove(function(e) {
    var $this = $(this);
    var $image = $this.find('.thumbnail_img_h');
    var thumbnailOffset = $this.offset();
    var offsetX = e.pageX - thumbnailOffset.left;
    var offsetY = e.pageY - thumbnailOffset.top;
    var thumbnailWidth = $this.outerWidth();
    var thumbnailHeight = $this.outerHeight();

    var imageX = (offsetX / thumbnailWidth) * 100;
    var imageY = (offsetY / thumbnailHeight) * 100;

    $image.css({
        'transform-origin': imageX + '% ' + imageY + '%',
    });
});
$('.thumbnail-image').click(function(){
    var $this = $(this);
    var $image = $this.find('.thumbnail_img_h');
    
    if ($image.hasClass('zoomed')) {
        // 图片已经放大，执行缩小操作
        $image.css({
            'transform': 'scale(1)',
            'cursor': 'zoom-in'
        });
        $image.removeClass('zoomed');
    } else {
        // 图片未放大，执行放大操作
        $image.css({
            'transform': 'scale(2)',
            'cursor': 'crosshair'
        });
        $image.addClass('zoomed');
    }
});

$('.thumbnail-image').mouseout(function(){
    var $this = $(this);
    var $image = $this.find('.thumbnail_img_h');
    $image.css({
        'transform': 'scale(1)',
    });
})